import { Injectable } from "@angular/core";
import * as global from "../../global";
import { API_URL } from "src/environments/api-url";
import { HttpService } from "src/app/services/http.service";
import { AuthService } from "src/app/services/auth.service";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class WoundCareWidgetService {
    private isStateChanged$ = new BehaviorSubject(false);
    public castState = this.isStateChanged$.asObservable();
    constructor(private authService: AuthService, private http: HttpService, private httpclient: HttpClient,) { }
    getAllDataset(company_id, project?:{}, dataSet?, page =null) {
        const data = {
            ...this.authService.authObject,
            company_id,
            dataSet,
            project,
            page
        };
        return this.http.post(global.url + API_URL.WOUND.getAllDataset, data);
    }
    setState(value) {
        this.isStateChanged$.next(value);
    }
    getWounds(patient_id, state) {
        const data = {
            ...this.authService.authObject,
            patient_id,
            company_id: this.authService.currentUser.company_id,
            state
        };
        return this.http.post(global.url + API_URL.WOUND.getWounds, data).pipe(
            // map((response) => {
            //     if (response.status == 200) {
            //         return {
            //             ...response,
            //             data: response.data.map((wound, i) => ({
            //                 woundNo: i + 1,
            //                 ...wound
            //             }))
            //         };
            //     }
            //     return response;
            // })
        );
    }
    getAllWoundsParentStatesCount(patient_id) {
        var data = {
            patient_id: patient_id,
            company_id: this.authService.currentUser.company_id
        }
        return this.httpclient.post(global.url + API_URL.WOUND.getAllWoundsParentStatesCount, { data: data }).pipe();
    }
    getChildWounds(patient_id, parent_id, dateFrom?, dateTo?) {
        const data = {
            ...this.authService.authObject,
            company_id: this.authService.currentUser.company_id,
            patient_id,
            parent_id,
            dateFrom,
            dateTo,
            checkkey: "web"
        };
        return this.http
            .post(global.url + API_URL.WOUND.getChildWounds, data)
            .pipe(
            // map((response) => {
            //     if (response.status == 200) {
            //         return {
            //             ...response,
            //             data: response.data.map((wound, i) => ({
            //                 woundNo: i + 1,
            //                 ...wound
            //             }))
            //         };
            //     }
            //     return response;
            // })
        );
    }
    updateWoundData(wound_id, woundData) {
        const data = {
            ...this.authService.authObject,
            wound_id, woundData
        };
        console.log({
            wound_id, woundData
        })
        return this.http.post(global.url + API_URL.WOUND.updateWoundData, data);
    }

    uploadWoundImage(imageFile, wound) {

        const payload = {
            auth: JSON.stringify(this.authService.authObject),
            data: JSON.stringify({
                wound_id: wound._id,
                patient_id: wound.patient_id
            })
        };

        const formData: any = new FormData();
        formData.append('file', imageFile);

        for (let key of Object.keys(payload)) {
            formData.append(key, payload[key]);
        }
        return this.httpclient.post(global.url + API_URL.WOUND.uploadWoundImages, formData).pipe();
    }
    deleteWoundOtherImages(wound_id, images) {
        const data = {
            id: wound_id,
            wound_images: images
        };
        return this.httpclient.post(global.url + API_URL.WOUND.deleteWoundOtherImages, { data: data }).pipe();
    }

    getWoundGraphData(wound_id) {
        const data = {
            ...this.authService.authObject,
            wound_id
        };
        return this.http.post(global.url + API_URL.WOUND.getWoundGraphData, data);
    }

    generateReportForAllWounds(patient, state) {
        let currUser: any = JSON.parse(localStorage.getItem("currentUser"));
        console.log("currUser", currUser);
        const headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'Content-Length');
        headers.append('Access-Control-Expose-Headers', 'Content-Length');
        headers.append('Content-Type', 'application/octet-stream');
        const data = {
            ...this.authService.authObject,
            patient_id: patient._id,
            patient,
            state,
            userId: currUser._id,
            company_id: currUser.company_id,
            isDownload: true
        };
        console.log("sending data", data);
        return this.httpclient.post(global.url + API_URL.WOUND.generateReportForAllWounds, data, {
            responseType: "blob",
            reportProgress: true,
            observe: 'events',
            headers
        });
    }

}
